import { render, staticRenderFns } from "./FabricCanvas.vue?vue&type=template&id=0df3dc2c"
import script from "./FabricCanvas.vue?vue&type=script&lang=js"
export * from "./FabricCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports